import React, { useEffect, useState } from 'react';
import { Button, FlexDirectionRow, MainContent, SubTitle, } from '../../../../../components/StyledComponents';
import { Grid } from '@mui/material';
import Select from '../../../../../components/Select';
import { useApp } from '../../../../../context/app';
import { useForm } from 'react-hook-form';
import InputControlled from '../../../../../components/InputControlled';
import { onlyNumbers, parseStringToJson, removeEmpty, sortByDirection, } from '../../../../../utils/utils';
import styles from '../../../../../components/TableAdmin/styles.module.scss';
import Spinner from 'react-spinner-material';
import { handleModalStatus } from '../../../../../utils/handleModalStatus';
import { BaSeDialogContext } from '@base/react';
import { UserActionsContent } from '../../../../../components/UserActionsContent';
import { AtendimentoService } from "../../../services/atendimentoService";
import { formatDateTime, stringToDate, formatHoursToBRWithoutSeconds } from "../../../../../utils/time";
import { CidadeService } from "../../../services/cidadeService";
import { valueIsRequired } from "../../../../../utils/regex";

export const Editar = () => {

  const { showModal } = React.useContext(BaSeDialogContext);
  const { setRenderIncludeScreen, manageItem } = useApp();
  const {
    control,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState,
    clearErrors,
  } = useForm({
    defaultValues: {
      id: null,
      cpf: null,
      cnpj: null,
      dataHoraInicio: '',
      dataHoraFim: '',
      porte: '',
      cep: '',
      endereco: '',
      bairro: '',
      cidade: null,
      uf: null,
      projetoAcao: null,
      idSas: '',
      codEstado: null,
      acao: null,
      nomeFantasia: null
    },
  });

  const [options, setOptions] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [cidades, setCidades] = useState([]);
  const [acoes, setAcoes] = useState([]);
    const [isManuallySubmitting, setIsManuallySubmitting] = useState(false);

  const onResetFields = () => {
    reset();
  };

  const getOptions = async () => {
    const response = await AtendimentoService.getFilterOptions(true);
    setOptions(response);
    setIsLoading(false);
  };

    const onSubmitForm = handleSubmit(async (dataForm) => {
        if (isManuallySubmitting) {
            return;
        }
        if (formState.isSubmitting || formState.isSubmitted || isManuallySubmitting) return;
        setIsManuallySubmitting(true);
        try {
            console.log('dataForm', dataForm);
            let sendForm = {
                id: dataForm.id || manageItem?.data?.id,
                cep: onlyNumbers(dataForm.cep),
                uf: parseStringToJson(dataForm.uf),
                porte: parseStringToJson(dataForm.porte),
                acao: parseStringToJson(dataForm.acao),
                cidade: parseStringToJson(dataForm.cidade),
                bairro: dataForm.bairro,
                endereco: dataForm.endereco,
                nomeFantasia: dataForm.nomeFantasia,
                dataHoraInicio: dataForm.dataHoraInicio
                    ? formatDateTime(dataForm.dataAtendimento, dataForm.dataHoraInicio)
                    : null,
                dataHoraFim: dataForm.dataHoraFim
                    ? formatDateTime(dataForm.dataAtendimento, dataForm.dataHoraFim)
                    : null,
            };
            if (sendForm.id) {
                await editItem(removeEmpty(sendForm));
            }
        } catch (error) {
            console.error('Erro ao submeter o formulário:', error);
        } finally {
            setIsManuallySubmitting(false);
        }
    });

  const handleGoHome = () => {
    setRenderIncludeScreen(false);
  };


  const getCidades = async (siglaUF) => {
    if (siglaUF) {
      try {
        const response = await CidadeService.findByUF(siglaUF);
        sortByDirection(response, 'nome', 'ASC');
        setCidades(response);
        return response;
      } catch (error) {
        console.error('Erro ao buscar cidades:', error);
      }
    }
  };

  const getAcaoByUF = async (siglaUF) => {
    if (siglaUF) {
      try {
        const response = await AtendimentoService.findAcoesByUF(siglaUF);
        setAcoes(response);
        return response
      } catch (error) {
        console.error('Erro ao buscar ações:', error);
      }
    }
  };

  const handleLabelProjetoAcao = (item) => {
    const { projeto } = item;
    if (projeto) {
      return (`${projeto.nuPratif} - ${projeto.nomePratif} - ${item.nomeAcao}`);
    }
    return item?.descricao ? item?.id + ' - ' + item?.descricao : item?.id + ' - ' + item?.nomeAcao
  }


  const editItem = async (dataForm) => {
    AtendimentoService.update(dataForm)
        .then((res) => {
          if (res.data) {
            handleModalStatus({
              type: 'success',
              msgOnSuccess: 'Atendimento foi editado com sucesso.',
              onCloseModal: handleGoHome,
              showModal,
            });
          } else {
            handleModalStatus({
              type: 'error',
              msgOnError:
                  'O atendimento não foi editado. Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.',
              showModal,
            });
          }
        })
        .catch(() =>
            handleModalStatus({
              type: 'error',
              msgOnError:
                  'O atendimento não foi editado. Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.',
              showModal,
            })
        );
  };


  useEffect(() => {
    const subscription = watch((value, { name }) => {
      if (name === 'uf') {
        clearErrors(['cidade'])
        const siglaUF = parseStringToJson(value?.uf)?.sigla;
        getCidades(siglaUF);
        getAcaoByUF(siglaUF);
      }
      return value;
    });
    return () => subscription.unsubscribe();
    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch]);

  useEffect(() => {
    const normalize = (str) =>
        str?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

    async function loadedData() {
      if (!options?.ufs?.length) return;

      try {
        const { data } = manageItem;

        const ufSigla = data?.empreendedor?.dadoComplementar?.siglaEstado || data?.empreendedor?.uf || data?.uf?.sigla;
        const ufSelecionada = options.ufs.find(u => u.sigla === ufSigla);
        const cidadesObtidas = await getCidades(ufSigla);
        const cidadeRaw = data?.empreendedor?.dadoComplementar?.cidade || data?.empreendedor?.cidade?.nome;
        const cidadeSelecionada = cidadesObtidas.find(c => normalize(c.nome) === normalize(cidadeRaw));
        const acoes = await getAcaoByUF(ufSelecionada?.sigla);
        const acaoSelecionada = acoes?.find(a => a.id === data?.apr?.acao?.id);

        console.log('Cidade esperada:', cidadeRaw);
        console.log('Cidades disponíveis:', cidadesObtidas.map(c => c.nome));
        console.log('Cidade selecionada:', cidadeSelecionada);

        setValue('cidade', cidadeSelecionada);
        setValue('uf', ufSelecionada);
        setValue('acao', acaoSelecionada);

      } catch (error) {
        console.error('Erro ao carregar dados:', error);
      }
    }

    loadedData();
    // eslint-disable-next-line
  }, [options]);

  useEffect(() => {
    getOptions();
  }, []);

  useEffect(() => {
    async function loadedData() {
      const { data } = manageItem;
      if (data?.id) {
        try {
          const { empreendedor } = data;

          delete data?.cidade?.uf;
          setValue('cnpj', empreendedor?.cnpj);
          setValue('cpf', (empreendedor?.respondente?.cpf ?? empreendedor?.cpfPessoaResponsavel));
          setValue('cep', empreendedor?.dadoComplementar?.cep);
          setValue('porte', empreendedor?.dadoComplementar?.porte);
          setValue('endereco', empreendedor?.logradouro);
          setValue('bairro', empreendedor?.bairro);
          setValue('dataAtendimento', stringToDate(data?.dataAtendimento));
          setValue('dataHoraInicio', formatHoursToBRWithoutSeconds(data?.apr?.inicioAtendimento));
          setValue('dataHoraFim', formatHoursToBRWithoutSeconds(data?.apr?.fimAtendimento));
          setValue('idSas', data?.apr?.codInteracaoSas ?? '');
          setValue('nomeFantasia', empreendedor?.dadoComplementar?.nomeFantasia);

        } catch (error) {
          console.error('Erro ao carregar dados:', error);
        }
      }
    }
    loadedData();
  }, [manageItem, setValue]);

  return (
    <>
      <MainContent>
        <SubTitle>
          <h3>{manageItem?.data?.id ? 'Editar' : 'Incluir'}</h3>
        </SubTitle>

        {isLoading ? (
          <div className={styles.spinnerCenter}>
            <Spinner radius={80} color={'#0061C6'} stroke={2} visible={true} />
            <p>Carregando...</p>
          </div>
        ) : (
          <Grid container style={{ paddingBottom: '30px' }}>
            {(
              <>
                <Grid container spacing={3}>
                  <Grid item md={2}>
                    <InputControlled
                      disabled={true}
                      mask="99.999.999/9999-99"
                      name="cnpj"
                      control={control}
                      placeholder="CNPJ"
                      maxLength={140}
                      showMaxLengthLabel={false}
                    />
                  </Grid>

                  <Grid item md={2}>
                    <InputControlled
                      disabled={true}
                      mask="999.999.999-99"
                      name="cpf"
                      control={control}
                      placeholder="CPF"
                      maxLength={140}
                      showMaxLengthLabel={false}
                    />
                  </Grid>

                  <Grid item md={2}>
                    <InputControlled
                      disabled={true}
                      name="idSas"
                      control={control}
                      placeholder="ID_SAS"
                      maxLength={140}
                      showMaxLengthLabel={false}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={3}>
                  <Grid item md={2}>
                    <InputControlled
                      type={'date'}
                      name="dataAtendimento"
                      control={control}
                      placeholder="Data"
                      maxLength={140}
                      showMaxLengthLabel={false}
                      rules={{ ...valueIsRequired() }}
                    />
                  </Grid>

                  <Grid item md={2}>
                    <InputControlled
                      type={'time'}
                      name="dataHoraInicio"
                      control={control}
                      placeholder="Hora Início"
                      maxLength={140}
                      showMaxLengthLabel={false}
                      rules={{ ...valueIsRequired() }}
                    />
                  </Grid>

                  <Grid item md={2}>
                    <InputControlled
                      type={'time'}
                      name="dataHoraFim"
                      control={control}
                      placeholder="Hora Fim"
                      maxLength={140}
                      showMaxLengthLabel={false}
                      rules={{ ...valueIsRequired() }}
                    />
                  </Grid>
                </Grid>


                <Grid container spacing={3}>
                  <Grid item md={2}>
                    <Select
                      name="porte"
                      returnItem
                      defaultName="nomePorte"
                      placeholder="Porte"
                      options={sortByDirection(options?.portes, 'nomePorte', 'ASC')}
                      control={control}
                      rules={{ ...valueIsRequired() }}
                    />
                  </Grid>

                  <Grid item md={2}>
                    <InputControlled
                      mask="99999-999"
                      name="cep"
                      control={control}
                      placeholder="CEP"
                      maxLength={140}
                      showMaxLengthLabel={false}
                      rules={{ ...valueIsRequired() }}
                    />
                  </Grid>

                </Grid>

                <Grid container spacing={3}>
                  <Grid item md={8}>
                    <InputControlled
                        name="nomeFantasia"
                        control={control}
                        placeholder="Razão Social"
                        maxLength={240}
                        showMaxLengthLabel={false}
                        rules={{ ...valueIsRequired() }}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={3}>
                  <Grid item md={8}>
                    <InputControlled
                      name="endereco"
                      control={control}
                      placeholder="Endereço"
                      maxLength={140}
                      showMaxLengthLabel={false}
                      rules={{ ...valueIsRequired() }}
                    />
                  </Grid>

                </Grid>

                <Grid container spacing={3}>
                  <Grid item md={2}>
                    <InputControlled

                      name="bairro"
                      control={control}
                      placeholder="Bairro"
                      maxLength={140}
                      showMaxLengthLabel={false}
                      rules={{ ...valueIsRequired() }}
                    />
                  </Grid>

                  <Grid item md={2}>
                    <Select
                      name="uf"
                      returnItem
                      defaultName="sigla"
                      placeholder="UF"
                      options={options?.ufs}
                      control={control}
                      rules={{ ...valueIsRequired() }}
                    />
                  </Grid>

                  <Grid item md={2}>
                    <Select
                      name="cidade"
                      returnItem
                      defaultName="nome"
                      placeholder="Cidade"
                      options={cidades}
                      control={control}
                      rules={{ ...valueIsRequired() }}
                    />
                  </Grid>

                </Grid>

                {
                  !!acoes.length &&
                  <Grid container spacing={3}>
                    <Grid item md={8}>
                      <Select
                        notRequired={true}
                        name="acao"
                        returnItem
                        formatOptionLabel={handleLabelProjetoAcao}
                        placeholder="Projeto/Ação"
                        options={acoes}
                        control={control}
                      />
                    </Grid>
                  </Grid>
                }

              </>
            )}

            <Grid container justifyContent="flex-end">
              <Grid item>
                <FlexDirectionRow position={'end'}>
                  {!manageItem?.data?.id && (
                    <Button
                      type={'button'}
                      backgroundColor={'#9CA2A8'}
                      onClick={onResetFields}
                    >
                      Limpar
                    </Button>
                  )}

                  <div style={{ marginLeft: '10px', marginRight: '10px' }} />
                    <Button
                        type="button"
                        onClick={onSubmitForm}
                        disabled={formState.isSubmitting || isManuallySubmitting}
                    >
                        {manageItem?.data?.id ? 'Editar' : 'Incluir'} atendimento
                    </Button>
                </FlexDirectionRow>
              </Grid>
            </Grid>
          </Grid>
        )}

      </MainContent>
      {manageItem?.data?.id && !isLoading && (
        <UserActionsContent data={manageItem?.data} />
      )}
    </>
  );
};
